import Container from 'saur_ui_library/src/Atoms/Container/Container';
import React, { useState } from 'react';
import { createGlobalStyle } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { closeContract } from '../../utils/helpers/observer';
import IconComponent from '../common/component/IconComponent';
import Importer from '../../assets/Tools/import.svg';
import Exporter from '../../assets/Tools/export.svg';
import Parameter from '../../assets/Tools/parameter.svg';
import Share from '../../assets/Tools/share.svg';
import Export from '../common/Export';
import Import from '../common/Import';
import Partage from '../common/Partage';

const ToolsMenu = () => {
  const navigate = useNavigate();

  const [showImport, setShowImport] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [showPartage, setShowPartage] = useState(false);

  const rendersPopups = () => {
    return (
      <>
      {showExport ? (
        <Export
          IsVisible={showExport}
          setModalVisible={() => {
            setShowExport(false);
          }}
        />
      ) : null}
      {showImport ? (
        <Import
          IsVisible={showImport}
          setModalVisible={() => {
            setShowImport(false);
          }}
        />
      ) : null}
      {showPartage ? (
        <Partage
          IsVisible={showPartage}
          setModalVisible={() => {
            setShowPartage(false);
          }}
        />
      ) : null}
      </>
    );
  }

  const divStylesIcons = {
    display: 'inline-flex',
    alignSelf: 'center',
    width: '205px',
    cursor: 'pointer',
    margin: '10px',
    height: '25px'
  };

  const titleStylesIcons = {
    width: 'max-content',
    alignSelf: 'center',
    fontSize: '14px',
  };

  const imgStyles = {
    marginRight: '10px',
  };

  return (
    <>
      {rendersPopups()}
      <Container className='list-menu-contract'>
        <Styles />
        {/* Param contract */}
        <IconComponent
          id={1}
          icon={Parameter}
          divStyles={divStylesIcons}
          title={'Paramétrage du contrat'}
          titleStyles={titleStylesIcons}
          imgStyles={imgStyles}
          event={() => {
            navigate('/Parametre');
            closeContract.setStatus(false);
          }}
        />
        {/* Partage */}
        <IconComponent
          id={2}
          icon={Share}
          divStyles={divStylesIcons}
          title={'Partage'}
          titleStyles={titleStylesIcons}
          imgStyles={imgStyles}
          event={() => {
            setShowPartage(true);
          }}
        />
        {/* Export data */}
        <IconComponent
          id={3}
          icon={Exporter}
          divStyles={divStylesIcons}
          title={'Exporter'}
          titleStyles={titleStylesIcons}
          imgStyles={imgStyles}
          event={() => {
            setShowExport(true);
          }}
        />
        {/* Import data */}
        <IconComponent
          id={4}
          icon={Importer}
          divStyles={divStylesIcons}
          title={'Importer'}
          titleStyles={titleStylesIcons}
          imgStyles={imgStyles}
          event={() => {
            setShowImport(true);
          }}
        />
      </Container>
    </>
  );
};
const Styles = createGlobalStyle`
.sds-reset-style{
  .list-menu-contract{
    font-weight: normal;
    .iconComponent:hover{
      border-radius: 10px;
      height: 25px;
      width: 205px;
      background-color: #1156B2;
    }
  }
}
`;
export default ToolsMenu;
